const colors = {
	primary: "#2596be",
	secondary: "#8186A0",
	backgroundLight: "#F9F9FC",
};

export default colors;
